export default {
  fr: {
    Study: {

      btn: {
        drop: "Drop",
        conversion: "Transformation",
        test: 'Essaye',     
        relay: 'Regroupement', 
        run: 'Course', 
        free: 'Jeu libre', 
      },

      drop: {
        feedback: "Un coup de pied de 45 mètres</br>largement suffisant",
        title: "Drop Goal",
        desc: "Seul le numéro 10 est autorisé à tenter un Drop. La situation doit être une sortie de Regroupement et il faut impérativement traverser la ligne d'en-but </br></br>On additionne le résultat de ton coup de dé à celui de l’adversaire pour calculer la distance de ce coup de pied. C’est 5 mètres par unité.",   
        instructions: "Avec 25 mètres garantis, un simple 2 est nécessaire pour réussir ton Drop. Utilise le 3 comme Relayeur puis le 10 et clique sur Drop",
      },

      conversion: {
        feedback: "Parfait,</br>pile entre les poteaux",
        title: "Transformation",
        desc: "Ce coup de pied est un coup de précision. Les dés représentent les poteaux, il te faut simplement un coup de dé compris dans cet intervalle pour réussir ta Transformation</br></br>Tu n’auras pas besoin de choisir un joueur.",   
        instructions: "Ton coup de dé devra être compris entre 6 et 2. Clique simplement sur Transformation",
      },

      forwards: {
        feedback: "Un double sur une Course</br>donne un Jeu libre",
        title: "",
        desc: "Un avant ne peut passer la balle qu'à un numéro qui le suit, le précède ou encore au numéro 9, le leader du groupe des avants.</br></br>Ce leader peut passer la balle à n’importe quel joueur de son groupe ou encore jouer avec le numéro 10. Chacun des joueurs qui composent la combinaison parcourent 10 mètres, sauf le Relayeur qui ne progresse pas.</br></br>La distance parcourue par le dernier joueur sera calculée en fonction du résultat d’un coup de dé, soit 5 mètres par unité pour une Course.",   
        instructions: "Utilise le numéro 1 comme Relayeur puis 9 - 5 - 6 pour une Course. Un double et tu rejoues",
      },

      backs: {
        feedback: "Un dé de 6 sur une Course</br>déclenchée à 25 mètres de l'en-but</br>donne toujours un essai",
        title: "",
        desc: "Un arrière peut passer la balle à n'importe quel joueur de son groupe ainsi qu’au leader de ce groupe, étant le numéro 10. Ce leader peut également jouer avec le numéro 9.</br></br>Ensuite, chacun des joueurs qui composent la combinaison parcourent 10 mètres, sauf le Relayeur qui ne progresse pas.</br></br>La distance parcourue par le dernier joueur sera calculée en fonction du résultat d’un coup de dé, soit 5 mètres par unité pour une Course.",
        instructions: "Essaye ceci : 9 - 10 - 15 - 12 - 13 pour un retour sur le 10 puis clique sur Course"
      },

      halfbacks: {
        feedback: "Un dé de 6 sur une Course</br>déclenchée à 25 mètres de l'en-but</br>donne toujours un essai",
        title: "",
        desc: "La Charnière 9 -10 est composée des leaders de chacun des groupes. Ils permettent la communication entre les groupes et augmentent considérablement les possibilités de combinaisons.</br></br>Ensuite, chacun des joueurs qui composent la combinaison parcourent 10 mètres, sauf le Relayeur qui ne progresse pas. La distance parcourue par le dernier joueur sera calculée en fonction du résultat d’un coup de dé, 5 mètres par unité pour une Course.",
        instructions: "Combine 9 - 6 - 7 - 9 - 10 - 12 puis clique sur Course"
      }
    }
  },
  en: {
    Study: {

      btn: {
        drop: "Drop",
        conversion: "Conversion",
        test: 'Try it',     
        relay: 'Relay', 
        run: 'Run', 
        free: 'Free play', 
      },

      drop: {
        feedback: "A 45 meters kick</br>is more than enough",
        desc: "Only #10 is allowed to attempt a Drop Goal. The situation must be a Relay and it is imperative for the ball to cross the goal line.</br></br>The result of your die is added to the opponent's to calculate the distance of the kick. This is 5 meters per unit.",
        title: "",   
        instructions: "With 25 meters guaranteed, a simple 2 is needed to successfully Drop. Use the 3 as a first-passer, the 10 and click on Drop.",
      },

      conversion: {
        feedback: "Perfect,</br>right through the uprights",
        title: "",
        desc: "This is a precision kick. Dice represent the posts, you just need to roll a die within this range to succeed in your Conversion. </br></br>You won't need to choose a player.",   
        instructions: "Just click on Conversion. Your die roll should be between 6 and 2",  
      },

      forwards: {
        feedback: "A double on a Run gives</br>a Free play",
        title: "",
        desc: "A forward can only pass the ball to a number that precedes,  follows him or to the number 9, the leader of the group.</br></br>Leader may pass the ball to any player in his group or play with the number 10. Each player in a combination moves 10 meters, except for the First passer who does not progress.</br></br>The distance covered by the last player will be calculated according to the result of a die roll, 5 meters per unit for a Run.",   
        instructions: "Use number 1 as first-passer and then 9 - 5 - 6 for a Run. Roll a double and you’ll play again", 
      },

      backs: {
        feedback: "A die of 6 on a Run triggered</br>25 meters away from the goal line</br>always results in a try",
        title: "",
        desc: "A back can pass the ball to any player in his group including the leader of the group, which is number 10. The leader can also play with number 9</br></br>Then, each of the players in the combination moves 10 meters, except for the first-passer who does not progress.</br></br>The distance covered by the last player will be calculated according to the result of a roll of the dice, 5 meters is given per unit for a Run.",   
        instructions: "Select 9 - 10 - 15 - 12 - 13 then pass it back to the 10 and then click on Run",  
      },

      halfbacks: {
        feedback: "A die of 6 on a Run triggered</br>25 meters from the goal line</br>always results in a try",
        title: "",
        desc: "The half-backs represent the leaders of each group. They ensure the link between the groups and considerably increase the possibilities of combinations.</br></br>Then, each of the players of the combination moves 10 meters, except for the first-passer who does not progress.</br></br>The distance traveled by the last player will be calculated according to the result of a roll of the die, 5 meters per unit for a Run.",   
        instructions: "Combine 9 - 6 - 7 - 9 - 10 - 12 then click on Run",  
      }
    }
  }
}


